
import MBaseModal from "@/components/MBaseModal.vue";
import MButton from "@/components/MButton.vue";
import MSelectBox from "@/components/form/MSelectBox.vue";
import MTextField from "@/components/form/MTextField.vue";
import MIconFileInput from "@/components/form/MIconFileInput.vue";
import MsStudentPicker from "@/components/student/MsStudentPicker.vue";
import MTextArea from "@/components/form/MTextArea.vue";
import MIcon from "@/components/MIcon.vue";
import { Options, Vue } from "vue-class-component";
import { Student } from "@/entities/student";
import { State } from "@/store/helper";
import {
  HeartRateAlertLabel,
  HeartRateAlertLevel,
  HeartRateAlertSetting,
  MAX_DURATION_SEC_LIMIT
} from "@/entities/heart_rate_alert_setting";
import { translateLevelTitle } from "@/utils/heart_rate_alert_setting";

@Options({
  components: {
    MBaseModal,
    MButton,
    MSelectBox,
    MIconFileInput,
    MTextField,
    MsStudentPicker,
    MIcon,
    MTextArea
  },
  emits: ["close", "execute", "ExecuteDelete"],
  props: {
    students: Array,
    setting: Object
  }
})
export default class HeartRateAlertSettingEditModal extends Vue {
  @State("allStudentsFetched") allStudentsFetched?: boolean;

  //生徒
  students: Student[] = [];
  setting!: HeartRateAlertSetting;

  // タイトル
  title = "";
  titleEntered = true;
  get validTitle() {
    return this.titleEntered && this.title.length > 0;
  }

  //心拍数の上限
  threshold = 0;
  thresholdEntered = true;
  get validThreshold() {
    return this.threshold && this.threshold > 0;
  }

  // levels
  alertLevels: HeartRateAlertLevel[] = [];

  enteredIndexes: number[] = [];

  get invalidLevelIndexes(): number[] {
    let indexes: number[] = [];
    for (let i = 0; i < this.alertLevels.length; i++) {
      if (
        this.alertLevels[i].minimumDurationSec <= 0 ||
        this.alertLevels[i].minimumDurationSec > this.maxSeconds
      ) {
        indexes.push(i);
      } else {
        indexes = indexes.filter(_ => _ !== i);
      }
    }
    return indexes;
  }

  get maxSeconds(): number {
    return this.getMaxSeconds();
  }

  getMaxSeconds() {
    return MAX_DURATION_SEC_LIMIT;
  }

  getLevelTitle(label: HeartRateAlertLabel) {
    return `「${translateLevelTitle(label)}」`;
  }

  // student
  selectedStudents: Student[] = [];
  defaultStudentIds: string[] = [];

  updateSelectedStudents(students: Student[]) {
    if (students.length === 0) {
      this.selectedStudents = [];
      return;
    }

    this.selectedStudents = [...students];
  }

  get validInput() {
    return (
      this.validTitle &&
      this.validThreshold &&
      this.invalidLevelIndexes.length === 0
    );
  }

  execute() {
    if (!this.validInput) return;
    this.$emit("execute", {
      title: this.title,
      threshold: this.threshold,
      alertLevels: this.alertLevels,
      targetStudentRefs: this.selectedStudents.map(_ => _.ref)
    });
  }

  executeDelete() {
    this.$emit("ExecuteDelete", this.setting.ref.id);
  }

  close() {
    this.$emit("close");
  }

  created() {
    this.title = this.setting.data.title;
    this.threshold = this.setting.data.threshold;
    this.alertLevels = this.setting.data.alertLevels.map(level => ({
      ...level
    }));
    this.defaultStudentIds = (this.setting.data.targetStudentRefs ?? []).map(
      ref => ref.id
    );
    this.selectedStudents = this.students.filter(student =>
      this.defaultStudentIds.includes(student.ref.id)
    );
    this.enteredIndexes = this.alertLevels.map((_, i) => i);
  }
}
